import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { ToggleSelect, PrimaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";

import { SpreadCreditModuleType } from "../LoanProceedsSettings/LoanProceedsSettings";

import { SpreadMatrices, CreditAdjustments, CompanyDropdown } from "./";
import "./styles.css";

const { SPREAD, CREDIT } = SpreadCreditModuleType;

const OPTIONS = [
  { name: SPREAD, index: 0 },
  { name: CREDIT, index: 1 }
];

const SpreadCreditModule = props => {
  const {
    authentication,
    moduleType,
    setModuleType,
    companies,
    onSaveSpreads,
    spreadMatrixSaveDisabled,
    creditAdjSaveDisabled,
    onSaveCreditAdjs,
    selectedSponsorCompanyId,
    setSelectedSponsorCompanyId,
    dropdownCompanies,
    setDropdownCompanies,
    isBroker
  } = props;

  const { companySponsorCompanies = [] } = companies;
  const moduleTypeIsSpread = moduleType === SPREAD;

  useEffect(() => {
    const { id: brokerId, name: brokerName } = authentication?.user?.contact?.company;
    const brokerCompany = {
      id: brokerId,
      name: brokerName,
      value: brokerId,
      label: brokerName
    };

    const sponsorCompanies = companySponsorCompanies?.map(({ id, name }) => ({
      id,
      name,
      value: id,
      label: name
    }));

    !isBroker ? setDropdownCompanies([brokerCompany]) : setDropdownCompanies([...sponsorCompanies]);
  }, [selectedSponsorCompanyId]);

  const handleCompanyChange = ({ id, isBroker }) => (isBroker ? setSelectedSponsorCompanyId(null) : setSelectedSponsorCompanyId(id));

  return (
    <>
      <div className="spread-credit-module-header-wrapper">
        <ToggleSelect
          options={OPTIONS}
          onChange={e => setModuleType(e?.name || moduleType)}
          requireSelection
        />
        {
          moduleTypeIsSpread && isBroker &&
            <PrimaryButton
              disabled={spreadMatrixSaveDisabled}
              className="assumptions-card-buttons"
              label="Save"
              size={ButtonSizeOptions.smFluid}
              onClick={onSaveSpreads}
            />
        }
        {
          !moduleTypeIsSpread && !isBroker &&
            <PrimaryButton
              disabled={creditAdjSaveDisabled}
              className="assumptions-card-buttons"
              label="Save"
              size={ButtonSizeOptions.smFluid}
              onClick={onSaveCreditAdjs}
            />
        }
      </div>
      {
        !moduleTypeIsSpread && isBroker &&
          <div className="spread-credit-module-header-wrapper">
            <CompanyDropdown
              providedCompanies={dropdownCompanies}
              selectedSponsorCompanyId={selectedSponsorCompanyId}
              handleChange={handleCompanyChange}
            />
            <PrimaryButton
              disabled={creditAdjSaveDisabled}
              className="assumptions-card-buttons"
              label="Save"
              size={ButtonSizeOptions.smFluid}
              onClick={onSaveCreditAdjs}
            />
          </div>
      }
      <div className="spread-credit-module-wrapper">
        {moduleType === SPREAD ? <SpreadMatrices {...props} /> : <CreditAdjustments {...props} isBroker={isBroker} />}
      </div>
    </>
  );
};

const mapStateToProps = ({ authentication, companies }) => ({ authentication, companies });

export default compose(connect(mapStateToProps))(SpreadCreditModule);
